<template>
  <div class="animated-bg" aria-hidden="true">
    <div class="blob blob--1"></div>
    <div class="blob blob--2"></div>
    <div class="blob blob--3"></div>
    <div class="blob blob--4"></div>
    <div class="mesh-overlay"></div>
  </div>
</template>

<style scoped>
.animated-bg {
  position: fixed;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.2;
  will-change: transform;
}

.blob--1 {
  width: 420px;
  height: 420px;
  top: -120px;
  left: -80px;
  background: radial-gradient(circle, rgba(23, 107, 137, 0.7), rgba(23, 107, 137, 0) 70%);
  animation: blobFloat1 12s ease-in-out infinite;
}

.blob--2 {
  width: 380px;
  height: 380px;
  top: 280px;
  right: -60px;
  background: radial-gradient(circle, rgba(47, 166, 109, 0.6), rgba(47, 166, 109, 0) 70%);
  animation: blobFloat2 14s ease-in-out infinite;
}

.blob--3 {
  width: 340px;
  height: 340px;
  bottom: 200px;
  left: 40px;
  background: radial-gradient(circle, rgba(24, 123, 181, 0.5), rgba(24, 123, 181, 0) 70%);
  animation: blobFloat3 10s ease-in-out infinite;
}

.blob--4 {
  width: 300px;
  height: 300px;
  bottom: 40px;
  right: 20px;
  background: radial-gradient(circle, rgba(33, 143, 136, 0.45), rgba(33, 143, 136, 0) 70%);
  animation: blobFloat2 16s ease-in-out infinite reverse;
}

.mesh-overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 20% 10%, rgba(23, 107, 137, 0.04) 0%, transparent 60%),
    radial-gradient(ellipse 70% 45% at 85% 90%, rgba(47, 166, 109, 0.03) 0%, transparent 55%),
    linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

@media (prefers-reduced-motion: reduce) {
  .blob {
    animation: none;
  }
}
</style>
